module.exports = __webpack_public_path__ + "img/rmv.4bc35e8b.png";